var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDashboardLicense(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3161_43413)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.5 9.33337C15.5167 9.33337 14 10.85 14 12.8334C14 14.8167 15.5167 16.3334 17.5 16.3334C19.4833 16.3334 21 14.8167 21 12.8334C21 10.85 19.4833 9.33337 17.5 9.33337ZM17.5 15.1667C16.2167 15.1667 15.1667 14.1167 15.1667 12.8334C15.1667 11.55 16.2167 10.5 17.5 10.5C18.7833 10.5 19.8333 11.55 19.8333 12.8334C19.8333 14.1167 18.7833 15.1667 17.5 15.1667Z",
    fill: "url(#paint0_linear_3161_43413)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.16663 4.66663H11.6666V5.83329H8.16663V4.66663Z",
    fill: "url(#paint1_linear_3161_43413)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.5 4.66663H5.83333V5.83329H3.5V4.66663Z",
    fill: "url(#paint2_linear_3161_43413)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.5 8.16663H9.33333V9.33329H3.5V8.16663Z",
    fill: "url(#paint3_linear_3161_43413)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.5 11.6666H8.16667V12.8333H3.5V11.6666Z",
    fill: "url(#paint4_linear_3161_43413)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.6667 0H2.33333C1.05 0 0 1.05 0 2.33333V21C0 22.2833 1.05 23.3333 2.33333 23.3333H10.5V22.1667H2.33333C1.63333 22.1667 1.16667 21.7 1.16667 21V2.33333C1.16667 1.63333 1.63333 1.16667 2.33333 1.16667H25.6667C26.3667 1.16667 26.8333 1.63333 26.8333 2.33333V21C26.8333 21.7 26.3667 22.1667 25.6667 22.1667H24.5V23.3333H25.6667C26.95 23.3333 28 22.2833 28 21V2.33333C28 1.05 26.95 0 25.6667 0Z",
    fill: "url(#paint5_linear_3161_43413)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5 5.83337C13.65 5.83337 10.5 8.98337 10.5 12.8334C10.5 14.9334 11.4333 16.8 12.8333 18.0834V28L17.5 25.6667L22.1667 28V18.0834C23.5667 16.8 24.5 14.9334 24.5 12.8334C24.5 8.98337 21.35 5.83337 17.5 5.83337ZM21 26.1334L17.5 24.3834L14 26.1334V23.3334V18.9C15.05 19.4834 16.2167 19.8334 17.5 19.8334C18.7833 19.8334 19.95 19.4834 21 18.9V26.1334ZM17.5 18.6667C14.2333 18.6667 11.6667 16.1 11.6667 12.8334C11.6667 9.56671 14.2333 7.00004 17.5 7.00004C20.7667 7.00004 23.3333 9.56671 23.3333 12.8334C23.3333 16.1 20.7667 18.6667 17.5 18.6667Z",
    fill: "url(#paint6_linear_3161_43413)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3161_43413",
    x1: 17.5,
    y1: 7.44807,
    x2: 17.5,
    y2: 17.5731,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00EFD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00ACEA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3161_43413",
    x1: 9.91663,
    y1: 4.35241,
    x2: 9.91663,
    y2: 6.03992,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00EFD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00ACEA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3161_43413",
    x1: 4.66667,
    y1: 4.35241,
    x2: 4.66667,
    y2: 6.03992,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00EFD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00ACEA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3161_43413",
    x1: 6.41667,
    y1: 7.85241,
    x2: 6.41667,
    y2: 9.53992,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00EFD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00ACEA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_3161_43413",
    x1: 5.83333,
    y1: 11.3524,
    x2: 5.83333,
    y2: 13.0399,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00EFD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00ACEA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_3161_43413",
    x1: 14,
    y1: -6.28435,
    x2: 14,
    y2: 27.4659,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00EFD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00ACEA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_3161_43413",
    x1: 17.5,
    y1: -0.136757,
    x2: 17.5,
    y2: 31.9259,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00EFD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00ACEA"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3161_43413"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDashboardLicense);
export default __webpack_public_path__ + "static/media/icon-dashboard-license.0b0b9b4ca1b63d41a655a89f90ec48e8.svg";
export { ForwardRef as ReactComponent };